var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 288,
    viewBox: "0 0 233 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M232.968 144.456C228.914 142.094 225.977 142.03 224.158 144.264C222.338 146.467 221.444 150.202 221.444 155.469V183.847C221.444 189.242 220.934 193.711 219.944 197.254C218.954 200.925 217.263 203.542 214.932 205.074C212.666 206.639 209.601 207.054 205.707 206.319C201.908 205.617 197.152 203.638 191.47 200.35L188.757 198.786V176.441L192.14 178.388C196.194 180.75 198.908 181.038 200.28 179.314C201.717 177.654 202.451 174.175 202.451 168.908V143.913C202.451 137.401 203.09 132.262 204.366 128.463C205.643 124.665 208.165 122.271 211.964 121.185C208.165 115.727 205.643 110.396 204.366 105.161C203.09 99.9257 202.483 94.0522 202.483 87.5403V62.5459C202.483 57.2789 201.749 53.0014 200.312 49.6497C198.972 46.3618 196.258 43.5527 192.172 41.1905L188.789 39.2433V16.8984L191.502 18.4626C197.184 21.7505 201.94 25.2299 205.739 28.9328C209.633 32.6676 212.698 36.6577 214.964 40.8394C217.326 45.0849 218.986 49.6178 219.976 54.4379C220.965 59.1303 221.476 64.2058 221.476 69.5686V97.9466C221.476 103.214 222.37 108.002 224.189 112.279C226.009 116.589 228.946 119.908 233 122.239L232.968 144.456Z",
    fill: "url(#paint0_linear_437_2918)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M130.022 62.2584C134.076 64.6206 137.012 64.6844 138.832 62.4499C140.651 60.2473 141.545 56.5125 141.545 51.2455V22.8675C141.545 17.4728 142.056 13.0038 143.046 9.46056C144.035 5.78961 145.663 3.14014 147.93 1.576C150.292 0.0437777 153.356 -0.371199 157.155 0.331069C161.049 1.06526 165.837 3.0763 171.519 6.36419L174.233 7.92834V30.2732L170.849 28.326C166.795 25.9639 164.018 25.6447 162.581 27.3046C161.241 29.0283 160.538 32.5077 160.538 37.7747V62.7691C160.538 69.2811 159.9 74.4204 158.623 78.219C157.346 81.9857 154.825 84.4117 151.026 85.4971C154.825 90.9556 157.346 96.2865 158.623 101.522C159.9 106.757 160.507 112.63 160.507 119.142V144.136C160.507 149.404 161.177 153.681 162.549 156.969C163.986 160.321 166.763 163.162 170.817 165.492L174.201 167.439V189.784L171.487 188.22C165.805 184.932 161.017 181.421 157.123 177.686C153.324 173.983 150.26 170.025 147.898 165.779C145.631 161.597 144.003 157.097 143.014 152.244C142.024 147.552 141.513 142.477 141.513 137.114V108.736C141.513 103.469 140.62 98.6806 138.8 94.4031C136.981 90.0937 134.044 86.7739 129.99 84.4437L130.022 62.2584Z",
    fill: "url(#paint1_linear_437_2918)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M220.199 154.032C216.145 151.67 213.209 151.606 211.389 153.841C209.569 156.043 208.676 159.778 208.676 165.045V193.423C208.676 198.818 208.165 203.287 207.175 206.83C206.186 210.501 204.494 213.118 202.164 214.651C199.897 216.215 196.833 216.63 192.938 215.896C189.14 215.193 184.384 213.214 178.702 209.926L175.988 208.362V186.017L179.372 187.964C183.426 190.327 186.139 190.614 187.512 188.89C188.948 187.23 189.683 183.751 189.683 178.484V153.489C189.683 146.978 190.321 141.838 191.598 138.04C192.875 134.241 195.396 131.847 199.195 130.761C195.396 125.303 192.875 119.972 191.598 114.737C190.321 109.502 189.714 103.628 189.714 97.1164V72.1221C189.714 66.855 188.98 62.5776 187.544 59.2259C186.203 55.938 183.49 53.1289 179.404 50.7667L176.02 48.8195V26.4746L178.734 28.0388C184.415 31.3266 189.172 34.8061 192.97 38.5089C196.865 42.2437 199.929 46.2339 202.196 50.4156C204.558 54.6611 206.218 59.1939 207.207 64.0141C208.197 68.7065 208.708 73.782 208.708 79.1447V107.523C208.708 112.79 209.601 117.578 211.421 121.855C213.24 126.165 216.177 129.485 220.231 131.815L220.199 154.032Z",
    fill: "url(#paint2_linear_437_2918)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M117.253 71.8348C121.307 74.197 124.244 74.2608 126.063 72.0263C127.883 69.8237 128.777 66.089 128.777 60.8219V32.4439C128.777 27.0492 129.287 22.5802 130.277 19.037C131.267 15.366 132.895 12.7166 135.161 11.1524C137.523 9.62019 140.588 9.20522 144.386 9.90749C148.281 10.6417 153.069 12.6527 158.751 15.9406L161.464 17.5048V39.8497L158.08 37.9025C154.026 35.5403 151.249 35.2211 149.813 36.881C148.472 38.6047 147.77 42.0841 147.77 47.3512V72.3455C147.77 78.8575 147.131 83.9968 145.855 87.7954C144.578 91.5621 142.056 93.9882 138.257 95.0735C142.056 100.532 144.578 105.863 145.855 111.098C147.131 116.333 147.738 122.207 147.738 128.719V153.713C147.738 158.98 148.408 163.257 149.781 166.545C151.217 169.897 153.995 172.738 158.049 175.068L161.432 177.015V199.36L158.719 197.796C153.037 194.508 148.249 190.997 144.354 187.262C140.556 183.559 137.491 179.601 135.129 175.356C132.863 171.174 131.235 166.673 130.245 161.821C129.256 157.128 128.745 152.053 128.745 146.69V118.312C128.745 113.045 127.851 108.257 126.031 103.98C124.212 99.6702 121.275 96.3503 117.221 94.0201L117.253 71.8348Z",
    fill: "url(#paint3_linear_437_2918)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M46.3881 3.90625L100.942 35.4126L100.91 166.066L46.3562 134.56L46.3881 3.90625Z",
    fill: "url(#paint4_linear_437_2918)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1414 23.9846L79.5224 49.0428V61.0772L36.1414 36.0189V23.9846Z",
    fill: "#5F27BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M53.1235 76.208L94.8127 100.277V118.983L53.1235 94.9139V76.208Z",
    fill: "#EEF0EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M53.0913 53.5759L94.8444 77.6765V82.0178L53.0913 57.9491V53.5759Z",
    fill: "#EEF0EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M53.0913 62.0669L89.1943 82.9115V87.2528L53.0913 66.4082V62.0669Z",
    fill: "#EEF0EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.3879 3.90625L100.941 35.4126V52.9374L46.3879 21.431V3.90625Z",
    fill: "url(#paint5_linear_437_2918)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.0182 20.6331C60.0182 23.2825 58.4541 24.5275 56.5388 23.4422C54.6235 22.3249 53.0913 19.2924 53.0913 16.6429C53.0913 13.9935 54.6555 12.7485 56.5707 13.8338C58.4541 14.9511 60.0182 17.9836 60.0182 20.6331Z",
    fill: "#EEF0EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M113.423 125.048L167.976 156.554L167.944 287.208L113.391 255.701L113.423 125.048Z",
    fill: "url(#paint6_linear_437_2918)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.204 163.066L177.585 188.092V200.095L134.172 175.068L134.204 163.066Z",
    fill: "url(#paint7_linear_437_2918)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M120.158 175.483L161.879 199.584V218.258L120.158 194.157V175.483Z",
    fill: "#EEF0EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M120.094 202.169L161.848 226.27V230.611L120.094 206.543V202.169Z",
    fill: "#EEF0EC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M120.094 210.022L156.197 230.867V235.208L120.094 214.363V210.022Z",
    fill: "#EEF0EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.423 125.048L167.976 156.554V174.079L113.423 142.572V125.048Z",
    fill: "url(#paint8_linear_437_2918)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.053 141.806C127.053 144.456 125.489 145.701 123.573 144.615C121.658 143.498 120.126 140.465 120.126 137.816C120.126 135.167 121.69 133.922 123.605 135.007C125.489 136.092 127.053 139.157 127.053 141.806Z",
    fill: "#EEF0EC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M103.974 143.147L9.00806 88.3379L9.03998 137.848L95.6424 187.837L104.038 200.254L103.974 143.147Z",
    fill: "url(#paint9_linear_437_2918)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M79.5541 141.104L58.7415 129.101V133.443L79.5541 145.445V141.104Z",
    fill: "#EEF0EC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M79.5542 149.818L28.0332 120.068V124.409L79.5861 154.16L79.5542 149.818Z",
    fill: "#EEF0EC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M79.5862 158.533L17.3716 122.621V126.963L79.5862 162.874V158.533Z",
    fill: "#EEF0EC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6936 148.605C84.6936 152.691 87.1196 157.384 90.0883 159.108C93.057 160.831 95.483 158.916 95.483 154.83C95.483 150.744 93.057 146.052 90.0883 144.328C87.0877 142.604 84.6936 144.52 84.6936 148.605Z",
    fill: "#D171CE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.3932 53.5758L5.81616 46.2978V42.0522L18.3932 49.3303C19.4146 49.9368 20.9149 51.1179 22.1918 52.9693C23.5644 54.9484 24.554 57.4383 24.554 60.1516C24.554 63.1522 23.7878 64.8441 22.3514 65.3548C20.9788 65.8017 19.3827 65.0356 18.3932 64.461L13.2219 61.4604L13.19 61.4285C12.7431 61.1731 12.0408 60.9177 11.4982 61.0773C11.0513 61.205 10.5086 61.6838 10.5086 63.3438C10.5086 65.0037 11.0193 66.0251 11.4662 66.6316C12.0089 67.3978 12.7112 67.9404 13.1581 68.1639L13.2219 68.1958L29.0549 77.3253V81.5708L13.3177 72.4732C12.2323 71.8987 10.6682 70.7176 9.3275 68.8342C7.85912 66.7593 6.83764 64.1418 6.83764 61.205C6.83764 58.3002 7.85912 56.7999 9.29558 56.3849C10.6363 56.0019 12.2004 56.5764 13.2857 57.2149L18.4251 60.1835C19.1593 60.5985 19.7338 60.79 20.085 60.6624C20.3723 60.5666 20.883 60.1516 20.883 58.0129C20.883 56.6084 20.4361 55.7146 19.9892 55.0761C19.4785 54.3739 18.8081 53.7993 18.3932 53.5758Z",
    fill: "#EEF0EC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55063 46.7447C9.55063 50.3837 7.4119 52.0756 4.79436 50.5753C2.17681 49.075 0.0380859 44.8933 0.0380859 41.2542C0.0380859 37.6152 2.17681 35.9234 4.79436 37.4237C7.4119 38.9559 9.55063 43.1376 9.55063 46.7447ZM34.7685 81.8581C34.7685 85.4972 32.6297 87.189 30.0122 85.6887C27.3946 84.1884 25.2559 80.0067 25.2559 76.3677C25.2559 72.7286 27.3946 71.0368 30.0122 72.5371C32.6297 74.0693 34.7685 78.251 34.7685 81.8581Z",
    fill: "#46F3B5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.7008 192.848C70.616 193.965 72.1483 196.615 72.1483 198.849V208.585L78.5964 212.288C80.5116 213.405 82.0439 216.055 82.0439 218.289C82.0439 220.492 80.4797 221.386 78.5964 220.3L72.1483 216.598V226.334C72.1483 228.536 70.5841 229.43 68.7008 228.345C66.7855 227.227 65.2533 224.578 65.2533 222.343V212.607L58.8052 208.905C56.8899 207.787 55.3577 205.138 55.3577 202.903C55.3577 200.701 56.9218 199.807 58.8052 200.892L65.2533 204.595V194.859C65.2533 192.625 66.7855 191.731 68.7008 192.848Z",
    fill: "url(#paint10_linear_437_2918)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_437_2918",
    x1: 2630.08,
    y1: 661.746,
    x2: -3384.58,
    y2: 11085.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_437_2918",
    x1: 2684.93,
    y1: 91.6657,
    x2: -3328.57,
    y2: 10513.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_437_2918",
    x1: 2617.31,
    y1: 671.322,
    x2: -3397.35,
    y2: 11095.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_437_2918",
    x1: 2672.16,
    y1: 101.242,
    x2: -3341.33,
    y2: 10523.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_437_2918",
    x1: 3096.21,
    y1: 3210.46,
    x2: -960.749,
    y2: 10238.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_437_2918",
    x1: 1918.77,
    y1: 496.473,
    x2: 3295.28,
    y2: 4399.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_437_2918",
    x1: 3163.24,
    y1: 3331.44,
    x2: -893.745,
    y2: 10360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_437_2918",
    x1: 155.878,
    y1: 163.066,
    x2: 155.878,
    y2: 200.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46F3B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_437_2918",
    x1: 1986.03,
    y1: 618.153,
    x2: 3362.53,
    y2: 4521.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_437_2918",
    x1: 6689.5,
    y1: 3589.3,
    x2: 2633.17,
    y2: 6765.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_437_2918",
    x1: 1747.93,
    y1: 1486.89,
    x2: 554.027,
    y2: 2428.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHero);
export default __webpack_public_path__ + "static/media/img_hero.179116a5b17212a21f6bd972307eb181.svg";
export { ForwardRef as ReactComponent };